import React, { useEffect, useState } from 'react';
import { Form, Table } from 'react-bootstrap';
import moment from 'moment';
import { CompactTable } from '@table-library/react-table-library/compact';
import { useTheme } from '@table-library/react-table-library/theme';
import { getTheme } from '@table-library/react-table-library/baseline';
import { usePagination } from '@table-library/react-table-library/pagination';
import ClipboardCopy from '../widgets/clipboard_copy';
import { isMobile } from 'react-device-detect'

import * as Constants from '../../helpers/constants';
import * as Helpers from '../../helpers/helper';

import 'react-toggle/style.css';
import '../../static/css/abuse.css';

const initialState = {
  pageSize: 50,
  currentValue: {},
  currentPageIndex: 0,
};

const AbuseListTable = ({ getAbuseList, data }) => {
  const [state, setState] = useState(initialState);
  // const theme = useTheme(getTheme());
  // let maxRows = Math.min(data.nodes.length, state.pageSize) + 1 //header plus rows
  const tableTheme = useTheme(
    [
      getTheme(),
      {
        Table: `
        --data-table-library_grid-template-columns: 
          minmax(12rem, 1fr) // Modified On
          minmax(10rem, 1fr) // Action Type
          minmax(10rem, 1fr) //  Action Type
          minmax(17rem, 1fr) //  Value
          minmax(10rem, 1fr) //  Block Free Email 
          minmax(25.5rem, 1fr) //Reason
          minmax(10rem, 1fr); // Updated By
          margin: 0px;
          grid-auto-rows: minmax(max-content, max-content);
        `,
        HeaderCell: `
        height: fit-content;
        border-top: 1px solid #dee2e6;
        border-left: 1px solid #dee2e6;
      `,
        Row: `
          font-size:14px;
          height: max-content;
        `,
        BaseCell: `
        font-size:14px;
        height: max-content;
        &:not(:last-of-type) {
          border-left: 1px solid #dee2e6;
        }
      `,
      }
    ]
  )

  useEffect(() => {
    getAbuseList(state.currentPageIndex * state.pageSize, state.pageSize, null, { created_on: 'desc' });
  }, [getAbuseList, state.pageSize, state.currentPageIndex]);

  const COLUMNS = [
    // {
    //   label: 'Sr No', renderCell: (item) => {
    //     console.log(item)
    //   }
    // },
    { label: 'Modified On', renderCell: (item) => <b>{createdOnTimeFormat(item.updatedAt)}</b> },
    {
      label: 'Action',
      renderCell: (item) => {
        const action = Helpers.removeUnderscore(item.task);
        return Helpers.capitalizeFirstLetter(action);
      }
    },
    {
      label: 'Action Type', renderCell: (item) => {
        const actionType = Helpers.removeUnderscore(item.name);
        return Helpers.capitalizeFirstLetter(actionType)
      }
    },
    {
      label: 'Value', renderCell: (item) => (
        <div className='d-flex justify-content-between text-wrap'>
          {item.data.domain ? item.data.domain : item.data.user_ip || item.data.latest_email || item.data.country}
          {item.data.domain || item.data.user_ip || item.data.latest_email || item.data.country ? (
            <ClipboardCopy textToCopy={item.data.domain || item.data.user_ip || item.data.country || item.data.latest_email} />
          ) : null}
        </div>
      )
    },
    { label: 'Block Free Email', renderCell: (item) => blockFreeEmailFormat(item) },
    { label: 'Reason', renderCell: (item) => <p className='text-wrap p-0 m-0'>{item.data.reason || '-'}</p> },
    { label: 'Updated By', renderCell: (item) => <b>{item.data?.crm_user_data?.name ?? 'SYSTEM'}</b> },
  ];

  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setState((prevState) => ({ ...prevState, pageSize: newSize, currentPageIndex: 0 }));
    getAbuseList(0, newSize, null, { created_on: 'desc' });
  };

  const createdOnTimeFormat = (cell) => {
    const date = moment(cell).format('DD-MMM-YYYY @ h:mm:ss a');
    return <span title={date}>{date}</span>;
  };

  const blockFreeEmailFormat = (blockFreeEmail) => {
    return blockFreeEmail.data.block_free_email ? 'Yes' : '-';
  };
  const onPaginationChange = (action, newState) => {
    getAbuseList(newState.page * LIMIT, LIMIT, null, { created_on: 'desc' });
    setState((prevState) => ({
      ...prevState,
      currentPageIndex: newState.page,
    }));
  };

  const LIMIT = state.pageSize;
  const pagination = usePagination(
    data,
    {
      state: {
        page: state.currentPageIndex,
        size: LIMIT,
      },
      onChange: onPaginationChange,
    }
  );

  return (
    <>
      <div className='table-container'>
        {data.nodes.length === 0 ? (
          <Table
            bordered
          >
            <thead className='fs-6'>
              <tr>
                {COLUMNS.map((column, index) => (
                  <th
                    className='fw-bold'
                    key={index}
                  >
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  colSpan={COLUMNS.length}
                  className='text-center pt-4'
                >
                  No data found
                </td>
              </tr>
            </tbody>
          </Table>
        ) : (
          <CompactTable
            columns={COLUMNS}
            data={data}
            theme={tableTheme}
            layout={{ fixedHeader: true, horizontalScroll: !isMobile, custom: true }}
          />
        )}
      </div>
      <div className='d-flex justify-content-between pt-3'>
        <Form.Select
          value={state.pageSize}
          onChange={handlePageSizeChange}
          className='vertical-pagination'
        >
          {Constants.PAGE_SIZE.values.map((size) => (
            <option
              key={size}
              value={size}
            >
              {size}
            </option>
          ))}
        </Form.Select>
        <div>
          <button
            type='button'
            disabled={pagination.state.page === 0}
            onClick={() => pagination.fns.onSetPage(0)}
          >
            {'|<'}
          </button>
          <button
            type='button'
            disabled={pagination.state.page === 0}
            onClick={() => pagination.fns.onSetPage(pagination.state.page - 1)}
          >
            {'<'}
          </button>
          <button
            type='button'
            onClick={() => pagination.fns.onSetPage(pagination.state.page + 1)}
          >
            {'>'}
          </button>
        </div>
      </div>
    </>
  );
};

export default AbuseListTable;
